import { useState, useRef, useEffect } from "react";
import { DRAG_HANDLE_RIGHT } from "../components/Cell/Index/DragHandleStyles.js";
import { useColumns, MIN_COLUMN_WIDTH, getResizedColumnId } from "../context/useColumnsContext.js";
const useResizeColumn = (colIndex, cellRef, dragHandleRef, tableId) => {
  const [dragging, setDragging] = useState(false);
  const { setColumnWidth } = useColumns();
  const draggableArea = useRef(document == null ? void 0 : document.createElement("div"));
  const width = useRef(0);
  const right = useRef(DRAG_HANDLE_RIGHT);
  const onMouseDown = (e) => {
    var _a;
    e.stopPropagation();
    width.current = Number((_a = cellRef == null ? void 0 : cellRef.current) == null ? void 0 : _a.style.width.replace("px", ""));
    setDragging(true);
    document.body.appendChild(draggableArea.current);
  };
  useEffect(() => {
    const currentDraggableArea = draggableArea.current;
    currentDraggableArea.setAttribute("id", "ghost");
    currentDraggableArea.setAttribute(
      "style",
      "position: absolute; top: 0; bottom: 0; left: 0; right: 0; z-index: 10000"
    );
    const handleMouseMove = (e) => {
      e.preventDefault();
      if (width.current && (dragHandleRef == null ? void 0 : dragHandleRef.current)) {
        width.current += e.movementX;
        right.current -= e.movementX;
        if (width.current > MIN_COLUMN_WIDTH) {
          dragHandleRef.current.setAttribute(
            "style",
            `right: ${right.current}px`
          );
        }
      }
    };
    const handleMouseUp = (e) => {
      e.stopPropagation();
      setDragging(false);
      requestAnimationFrame(() => {
        const resizedColumnId = getResizedColumnId(tableId, colIndex);
        const resizedWidth = width.current < MIN_COLUMN_WIDTH ? MIN_COLUMN_WIDTH : width.current;
        setColumnWidth(resizedColumnId, resizedWidth);
        setTimeout(() => {
          var _a;
          (_a = dragHandleRef == null ? void 0 : dragHandleRef.current) == null ? void 0 : _a.removeAttribute("style");
          right.current = DRAG_HANDLE_RIGHT;
        }, 200);
        document.body.removeChild(draggableArea.current);
      });
    };
    currentDraggableArea.addEventListener("mousemove", handleMouseMove);
    currentDraggableArea.addEventListener("mouseup", handleMouseUp);
    return () => {
      if (!currentDraggableArea)
        return;
      currentDraggableArea.removeEventListener("mousemove", handleMouseMove);
      currentDraggableArea.removeEventListener("mouseup", handleMouseUp);
    };
  }, [colIndex, dragHandleRef, setColumnWidth, tableId]);
  const getOnDragProps = () => ({
    dragging,
    onMouseDown
  });
  return { dragging, getOnDragProps };
};
export {
  useResizeColumn
};
